module.exports = __webpack_public_path__ + "img/logo.3efe2e39.png";